module.exports = __webpack_public_path__ + "img/noble-level3-bg.2c994f36.png";